/**
 * @fileoverview added by tsickle
 * Generated from: models/applicant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {string} */
var ApplicantState = {
    Closed: "closed",
    Applied: "applied",
    Success: "success",
    Rejected: "rejected",
    Forgot: "forgot",
};
export { ApplicantState };
/** @enum {string} */
var PhoneType = {
    Android: "android",
    Smart: "smart",
    Iphone: "iphone",
    NonSmart: "nonsmart",
};
export { PhoneType };
/**
 * @record
 */
export function DeclaredAvailableWeekday() { }
if (false) {
    /** @type {?} */
    DeclaredAvailableWeekday.prototype.day;
    /** @type {?} */
    DeclaredAvailableWeekday.prototype.available;
}
/**
 * @record
 */
export function InterviewNotes() { }
if (false) {
    /** @type {?|undefined} */
    InterviewNotes.prototype.experience;
    /** @type {?|undefined} */
    InterviewNotes.prototype.hours;
    /** @type {?|undefined} */
    InterviewNotes.prototype.areas;
}
/**
 * @record
 */
export function ApplicantDocument() { }
if (false) {
    /** @type {?} */
    ApplicantDocument.prototype.id;
    /** @type {?} */
    ApplicantDocument.prototype.created;
    /** @type {?} */
    ApplicantDocument.prototype.documentType;
    /** @type {?} */
    ApplicantDocument.prototype.isVerified;
    /** @type {?|undefined} */
    ApplicantDocument.prototype.part;
    /** @type {?|undefined} */
    ApplicantDocument.prototype.isImage;
    /** @type {?|undefined} */
    ApplicantDocument.prototype.url;
}
/** @type {?} */
export var applicantDocument = model.extend({
    modelName: 'applicantDocument'
});
/**
 * @record
 */
function BaseApplicant() { }
if (false) {
    /** @type {?} */
    BaseApplicant.prototype.age;
    /** @type {?} */
    BaseApplicant.prototype.calls;
    /** @type {?} */
    BaseApplicant.prototype.canBringNi;
    /** @type {?} */
    BaseApplicant.prototype.claimsToHaveDownloadedApp;
    /** @type {?} */
    BaseApplicant.prototype.claimsToHaveDownloadedZoom;
    /** @type {?} */
    BaseApplicant.prototype.criminalConvictions;
    /** @type {?} */
    BaseApplicant.prototype.dateOfBirth;
    /** @type {?} */
    BaseApplicant.prototype.days;
    /** @type {?} */
    BaseApplicant.prototype.email;
    /** @type {?} */
    BaseApplicant.prototype.experience;
    /** @type {?} */
    BaseApplicant.prototype.firstNames;
    /** @type {?} */
    BaseApplicant.prototype.fullName;
    /** @type {?} */
    BaseApplicant.prototype.gender;
    /** @type {?} */
    BaseApplicant.prototype.hasDbsCertificate;
    /** @type {?} */
    BaseApplicant.prototype.hasDownloadedApp;
    /** @type {?} */
    BaseApplicant.prototype.hasRtw;
    /** @type {?} */
    BaseApplicant.prototype.hasUploadedDocuments;
    /** @type {?} */
    BaseApplicant.prototype.haveBankAccount;
    /** @type {?} */
    BaseApplicant.prototype.acceptsSelfEmployment;
    /** @type {?} */
    BaseApplicant.prototype.howLongPlanToBeCleaner;
    /** @type {?} */
    BaseApplicant.prototype.howManyHoursCleaningWanted;
    /** @type {?} */
    BaseApplicant.prototype.howLearnedHomeCleaning;
    /** @type {?} */
    BaseApplicant.prototype.id;
    /** @type {?} */
    BaseApplicant.prototype.idDocument;
    /** @type {?} */
    BaseApplicant.prototype.internalId;
    /** @type {?|undefined} */
    BaseApplicant.prototype.interviewNotes;
    /** @type {?} */
    BaseApplicant.prototype.ironing;
    /** @type {?} */
    BaseApplicant.prototype.lastName;
    /** @type {?} */
    BaseApplicant.prototype.lengthOfExperience;
    /** @type {?} */
    BaseApplicant.prototype.mostRecentApplication;
    /** @type {?} */
    BaseApplicant.prototype.nationality;
    /** @type {?} */
    BaseApplicant.prototype.noshows;
    /** @type {?} */
    BaseApplicant.prototype.opsQualityRating;
    /** @type {?} */
    BaseApplicant.prototype.phoneType;
    /** @type {?} */
    BaseApplicant.prototype.postcode;
    /** @type {?} */
    BaseApplicant.prototype.primaryTelephoneNumber;
    /** @type {?} */
    BaseApplicant.prototype.rejectReason;
    /** @type {?} */
    BaseApplicant.prototype.requiresDbsDocumentUpload;
    /** @type {?} */
    BaseApplicant.prototype.resultingWorkerId;
    /** @type {?} */
    BaseApplicant.prototype.state;
    /** @type {?} */
    BaseApplicant.prototype.stageDisplay;
    /** @type {?} */
    BaseApplicant.prototype.travelPreferences;
    /** @type {?} */
    BaseApplicant.prototype.typesOfExperience;
    /** @type {?} */
    BaseApplicant.prototype.worksWithDogs;
    /** @type {?} */
    BaseApplicant.prototype.worksWithCats;
    /** @type {?} */
    BaseApplicant.prototype.worksWithOtherPets;
}
/**
 * @record
 */
function ApplicantExpandables() { }
if (false) {
    /** @type {?|undefined} */
    ApplicantExpandables.prototype.documents;
    /** @type {?|undefined} */
    ApplicantExpandables.prototype.location;
    /** @type {?|undefined} */
    ApplicantExpandables.prototype.areas;
}
/**
 * @record
 */
function ApplicantModelMixin() { }
if (false) {
    /** @type {?} */
    ApplicantModelMixin.prototype.isOpen;
    /** @type {?} */
    ApplicantModelMixin.prototype.isRejected;
    /** @type {?} */
    ApplicantModelMixin.prototype.opsUrl;
    /** @type {?|undefined} */
    ApplicantModelMixin.prototype.photoUrl;
}
/**
 * @record
 */
export function Applicant() { }
/** @type {?} */
export var applicant = model.extend({
    modelName: 'applicant'
});
defineModelProperties(applicant, {
    isOpen: {
        get: /**
         * @return {?}
         */
        function () {
            return this.state === ApplicantState.Applied;
        }
    },
    isRejected: {
        get: /**
         * @return {?}
         */
        function () {
            return this.state === ApplicantState.Rejected;
        }
    },
    photoUrl: {
        get: /**
         * @return {?}
         */
        function () {
            var _a;
            this.documents.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return b.created.unix() - a.created.unix(); }));
            return (((_a = this.documents.find((/**
             * @param {?} doc
             * @return {?}
             */
            function (doc) { return doc.documentType === 'profile'; }))) === null || _a === void 0 ? void 0 : _a.url) ||
                '/static/marketing/design-tokens/images/user-avatar.svg');
        }
    },
    opsUrl: {
        get: /**
         * @return {?}
         */
        function () {
            return "/hkadmin/recruit/applicants/" + this.internalId + "/";
        }
    }
});
